import React from 'react';

import { Box, IconButton, ListItem, ListItemSecondaryAction, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Delete, Edit } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  departmentItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    backgroundColor: '#F2F2F2',
    borderRadius: 6,
    fontSize: 12,
    padding: '10px 20px',
  },
}));

const DepartmentListItem = ({ department, facilityId, onEditDepartment, onDeleteDepartment, onMouseEnter, onMouseLeave }) => {
  const classes = useStyles();

  return (
    <ListItem key={department.id} className={classes.departmentItem} onMouseEnter={() => onMouseEnter(department.id)} onMouseLeave={onMouseLeave}>
      <Box display="flex" gridGap={16}>
        <span style={{ fontWeight: 'bold' }}>{department.name}</span>
        {department.id && <span>Id: {department.id}</span>}
        {department.code && <span>Code: {department.code}</span>}
      </Box>

      <ListItemSecondaryAction>
        <div>
          <Tooltip title="Edit Department">
            <IconButton
              edge="end"
              size="small"
              onClick={() => {
                onEditDepartment(department.id, facilityId);
              }}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete Department">
            <IconButton
              edge="end"
              size="small"
              color="secondary"
              onClick={() => {
                onDeleteDepartment(department.id, facilityId);
              }}>
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default DepartmentListItem;
